var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// @ts-nocheck
import moment from "moment";
import { getMD5Encode } from "./utils";
const eventsPush = {
    maxLen: 2048,
    init(config) {
        this.config = config;
        // 初始化的时候先读取缓存中的队列数据
        this.queue = JSON.parse((localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("queue")) || "[]");
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("queue", "[]");
        // 浏览器关闭前将队列中未清除的数据缓存起来
        const self = this;
        window.onbeforeunload = function (ev) {
            var _a;
            const maxStoreLen = 1024;
            const storeQueue = [];
            const reverseQueue = self.queue.reverse();
            for (let i = 0, len = reverseQueue === null || reverseQueue === void 0 ? void 0 : reverseQueue.length; i < len; i++) {
                if (((_a = JSON.stringify(storeQueue.concat(reverseQueue[i]))) === null || _a === void 0 ? void 0 : _a.length) <
                    maxStoreLen) {
                    storeQueue.push(reverseQueue[i]);
                }
                else {
                    break;
                }
            }
            const e = ev || window.event;
            if (e) {
                localStorage.setItem("queue", JSON.stringify(self.queue || []));
            }
        };
        console.log("sdk init =>", config);
    },
    getEncodeStr(data) {
        return encodeURIComponent(JSON.stringify(data));
    },
    getDecodeStr(data) {
        return JSON.parse(decodeURIComponent(data));
    },
    send() {
        const { server_url, corp_id = "" } = this.config;
        // 真正发送时的url
        let sendUrl = server_url;
        // 计算url长度用的url
        let fakeUrl = server_url;
        const targetArr = [];
        while (fakeUrl.length < this.maxLen && this.queue.length) {
            const _a = this.getDecodeStr(this.queue[0]), { cur_time } = _a, target = __rest(_a, ["cur_time"]);
            const sendTime = moment().unix();
            target.relative_time = sendTime - cur_time;
            targetArr.push(target);
            const data = this.getEncodeStr(targetArr);
            const sign = getMD5Encode(`${corp_id}${JSON.stringify(targetArr)}${sendTime}`);
            fakeUrl = `${server_url}&corp_id=${corp_id}&data=${data}&time=${sendTime}&sign=${sign}`;
            if (fakeUrl.length < this.maxLen) {
                sendUrl = fakeUrl;
                this.queue.shift();
            }
        }
        // 发送埋点数据，如果队列里还有数据，继续定时发送
        const img = new Image();
        img.src = sendUrl;
        console.log("sdk send =>", sendUrl, this.queue.length);
        if (this.queue.length) {
            // if (this.scanTime) {
            //   clearTimeout(this.scanTime);
            // }
            // this.scanTime = setTimeout(
            //   (self) => {
            //     self.send();
            //   },
            //   1000,
            //   this
            // );
            this.send();
        }
    },
    track(eventsData) {
        var _a;
        if (!((_a = this.config) === null || _a === void 0 ? void 0 : _a.server_url)) {
            console.log("请设置server_url");
            return;
        }
        console.log("sdk track =>", eventsData);
        const data = this.getEncodeStr(eventsData);
        this.queue.push(data);
        // 如果禁用cookie，直接发送埋点数据，否则埋点数据先加入队列，定时发送；否则
        // if (localStorage?.setItem) {
        //   if (this.sendTime) {
        //     clearTimeout(this.sendTime);
        //   }
        //   this.sendTime = setTimeout(
        //     (self) => {
        //       self.send();
        //     },
        //     1000,
        //     this
        //   );
        // } else {
        //   this.send();
        // }
        this.send();
    },
};
export default eventsPush;
